/** Onde o atendimento acontece — espelho de `PACK_LOCATION_MODE` na API. */
export enum LOCATION_MODE {
  /** O cliente vai até o prestador, num endereço fixo. */
  PROVIDER_SPACE = 'PROVIDER_SPACE',
  /** O prestador vai até o cliente. */
  CLIENT_ADDRESS = 'CLIENT_ADDRESS',
  /** Atendimento remoto. */
  ONLINE = 'ONLINE',
}
